import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import './App.css';
import { Toaster } from './components/ui/sonner';
import { Header } from './components/Header';
import { HeroSectionDark } from './components/HeroSectionDark';
import { MenuSectionDark } from './components/MenuSectionDark';
import { AboutSectionDark } from './components/AboutSectionDark';
import { VIPSection } from './components/VIPSection';
import { ContactSectionDark } from './components/ContactSectionDark';
import { OrderModal } from './components/OrderModal';
import { FooterDark } from './components/FooterDark';
import { AdminPage } from './pages/AdminPage';
import { KitchenPage } from './pages/KitchenPage';

// Main landing page component
function LandingPage({ initialReferralCode = '' }) {
  const [cart, setCart] = useState([]);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);

  // Auto-open the order modal when landing via a referral short-link (/r/:code)
  useEffect(() => {
    if (initialReferralCode) {
      setIsOrderModalOpen(true);
    }
  }, [initialReferralCode]);

  const handleAddToCart = (item) => {
    const cartItem = {
      id: item.id,
      name: item.name,
      price: item.price || 0,
      description: item.description || '',
      image: item.image || 'https://images.unsplash.com/photo-1569058242253-92a9c755a0ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwxfHxmcmllZCUyMGNoaWNrZW58ZW58MHx8fHwxNzY1NDc1NjMyfDA&ixlib=rb-4.1.0&q=85',
      quantity: 1
    };
    
    const existingItem = cart.find(cartItem => cartItem.id === item.id);
    
    if (existingItem) {
      setCart(cart.map(cartItem =>
        cartItem.id === item.id
          ? { ...cartItem, quantity: cartItem.quantity + 1 }
          : cartItem
      ));
    } else {
      setCart([...cart, cartItem]);
    }
  };

  const handleUpdateCart = (itemId, newQuantity) => {
    if (newQuantity <= 0) {
      handleRemoveFromCart(itemId);
      return;
    }
    
    setCart(cart.map(item =>
      item.id === itemId ? { ...item, quantity: newQuantity } : item
    ));
  };

  const handleRemoveFromCart = (itemId) => {
    setCart(cart.filter(item => item.id !== itemId));
  };

  const getTotalCartCount = () => {
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  };

  const handleOpenOrderModal = () => {
    setIsOrderModalOpen(true);
  };

  return (
    <div className="App">
      <Header 
        cartCount={getTotalCartCount()} 
        onCartClick={handleOpenOrderModal}
      />
      
      <main className="bg-black">
        <HeroSectionDark onOrderClick={handleOpenOrderModal} />
        <MenuSectionDark onAddToCart={handleAddToCart} />
        <AboutSectionDark />
        <VIPSection />
        <ContactSectionDark />
      </main>

      <FooterDark />

      <OrderModal
        isOpen={isOrderModalOpen}
        onClose={() => setIsOrderModalOpen(false)}
        cart={cart}
        onUpdateCart={handleUpdateCart}
        onRemoveFromCart={handleRemoveFromCart}
        initialReferralCode={initialReferralCode}
      />

      <Toaster position="top-center" richColors />
    </div>
  );
}

function ReferralLanding() {
  const { code } = useParams();
  return <LandingPage initialReferralCode={(code || '').toUpperCase()} />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/r/:code" element={<ReferralLanding />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/cocina" element={<KitchenPage />} />
      </Routes>
    </Router>
  );
}

export default App;
